/**
 * @generated SignedSource<<2802cda5a0b11177f0fedc71a0882ff7>>
 * @relayHash 2901a985ee0918584795e58494457219
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID dd4d89a2e5b65ffc3702a8345417aaf05c1343f71446bf84ac64342012e941db

import type { ConcreteRequest } from 'relay-runtime';
export type PageAgentSessionNudgesSubscription$variables = {
  accountId: string;
  cloudId: string;
  workspaceAri: string;
};
export type PageAgentSessionNudgesSubscription$data = {
  readonly convoai_onInboxSessionChanged: {
    readonly sessionAri: string;
    readonly sessionId: string;
  } | null;
};
export type PageAgentSessionNudgesSubscription = {
  response: PageAgentSessionNudgesSubscription$data;
  variables: PageAgentSessionNudgesSubscription$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "accountId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "workspaceAri"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "accountId",
        "variableName": "accountId"
      },
      {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
      },
      {
        "kind": "Variable",
        "name": "workspaceAri",
        "variableName": "workspaceAri"
      }
    ],
    "concreteType": "ConvoAiInboxSessionChanged",
    "kind": "LinkedField",
    "name": "convoai_onInboxSessionChanged",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "sessionAri"
      },
      {
        "kind": "ScalarField",
        "name": "sessionId"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "PageAgentSessionNudgesSubscription",
    "selections": (v1/*: any*/),
    "type": "Subscription"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PageAgentSessionNudgesSubscription",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "2901a985ee0918584795e58494457219",
    "id": "dd4d89a2e5b65ffc3702a8345417aaf05c1343f71446bf84ac64342012e941db",
    "metadata": {},
    "name": "PageAgentSessionNudgesSubscription",
    "operationKind": "subscription",
    "text": "subscription PageAgentSessionNudgesSubscription($accountId:String!,$cloudId:ID!,$workspaceAri:ID!){convoai_onInboxSessionChanged(accountId:$accountId,cloudId:$cloudId,workspaceAri:$workspaceAri)@optIn(to:[\"ConvoAiInboxSessionChanged\"]){sessionAri,sessionId}}"
  }
};
})();

(node as any).hash = "2da934814d2a6404a4bc4ec5f6d561ce";

export default node;
